import React from 'react';
import { Box, Grid, Typography, useTheme, useMediaQuery } from '@mui/material';
import Hai from './Hai';
import { sortHais } from '../haiUtils';

const styles = {
  area: {
    marginBottom: '20px',
  },
  furoBox: {
    padding: { xs: '4px', sm: '10px' }, // 画面サイズに応じて余白を調整
    border: '2px solid #ccc',
    borderRadius: '5px',
    // 高さを固定し、内容物によって高さが変わらないようにする
    height: { xs: '35px', sm: '70px' },
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box', // paddingとborderを高さに含める
  },
  hai: {
    cursor: 'pointer',
  },
  active: {
    borderColor: '#2196f3', // Blue color to indicate active area
    backgroundColor: '#e3f2fd', // Light blue background
  },
};

const FuroArea = ({ furos, onRemove, onAreaSelect, activeFuro }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={styles.area}>
      <Typography variant="subtitle2" gutterBottom>副露</Typography>
      <Grid container spacing={2}>
        {furos.map((furo, furoIndex) => (
          <Grid item key={furoIndex} xs={6} sm={3}>
            <Box
              sx={{ ...styles.furoBox, ...(activeFuro === furoIndex ? styles.active : {}), cursor: 'pointer' }}
              onClick={() => onAreaSelect(`furo-${furoIndex}`)}
            >
              {/* 牌を左寄せで配置し、画面サイズに応じて牌同士の隙間を調整する */}
              <Box sx={{ display: 'flex', flexWrap: 'nowrap', width: '100%', height: '100%', alignItems: 'center', justifyContent: 'flex-start', gap: { xs: '4px', sm: '2px' } }}>
                {sortHais(furo).map((haiId, index) => (
                  <Box
                    key={`${haiId}-${index}`}
                    sx={{
                      // PCでは幅を基準にし、スマホでは高さを基準にする
                      width: { sm: '25%' },
                      height: { xs: '100%', sm: 'auto' },
                      cursor: 'pointer',
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      onRemove(`furo-${furoIndex}`, index);
                    }}
                  >
                    <Hai
                      haiId={haiId}
                      style={isMobile ? { height: '100%', width: 'auto' } : { width: '100%', height: 'auto' }}
                    />
                  </Box>
                ))}
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default FuroArea;